<template>
    <div class="author-review">
        <div class="author-review--row">
            <div class="author-box evaluation-author-box">
                <div class="author-box--photo">
                    <span class="avatar" :class="evaluation.random_avatar_layout">
                        {{ evaluation.first_name_character }}
                    </span>
                </div>

                <div class="author-box--name">
                    <h4>{{ evaluation.name }}</h4>
                    <p>{{ evaluation.created_at_formatted }}</p>
                </div>

                <div class="author-box--evaluation">
                    <EvaluationResult :ratingExtraClass="`small-result mark-${evaluation.grade}`" />
                </div>
            </div>
        </div>

        <div v-if="hiddenContent" class="author-review--row review-row">
            <div class="hidden-review-row">
                <strong>Upozornenie</strong>, recenzia prezrádza časti deja. <span class="btn-show-more" @click="hiddenContent = false">Ukázať recenziu</span>
            </div>
        </div>

        <div v-if="!hiddenContent" class="author-review--row review-row">
            <h3 v-if="evaluation.title">{{ evaluation.title }}</h3>
            <p v-if="evaluation.text">{{ evaluation.text }}</p>

            <div class="evaluation-footer">
                <div class="evaluation-footer--box">
                    <span class="btn btn-text-action-blue btn-text-small btn-icon-left icon-like" @click="recordLike()">
                        {{ evaluation.likes }}
                    </span>
                </div>

                <div class="evaluation-footer--box">
                    <span v-if="!reported" class="btn btn-text-action-black" @click="report()">Nahlásiť recenziu</span>
                    <span v-if="reported" class="btn btn-text-action-green btn-green-check">Recenzia nahlásená. Ďakujeme.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EvaluationResult from './EvaluationResult'

    export default {
        components: {
            EvaluationResult
        },
        emits: ['update-likes'],
        props: {
            evaluation: {
                type: Object
            }
        },
        data() {
            return {
                hiddenContent: this.evaluation.spoiler,
                reported: false
            }
        },
        methods: {
            recordLike () {
                if ( localStorage.getItem(`evaluation_like_${this.evaluation.id}`) ) return alert('Jednému hodnoteniu môžete udeliť maximálne jeden like.')

                axios.get(`/api/shop/evaluation/${this.evaluation.id}/like`)
                .then( response => {

                    this.$emit('updateLikes', response.data.likes)
                    localStorage.setItem(`evaluation_like_${this.evaluation.id}`, true)
    
                }).catch( errors => { console.log( errors.response.data.errors ) })
            },
            report() {
                axios.get(`/api/shop/evaluation/${this.evaluation.id}/report`)
                .then( response => { this.reported = true })
                .catch( errors => { console.log( errors.response.data.errors ) })
            }
        }
    }
</script>